import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import HorizontalStack from '../horizontal-stack';
import { SPACING } from '../horizontal-stack/constants';
import IconButton from '../icon-button';

const ActionRadioGroup = ({ options, onChange = null, selectedId, gap = 'auto', wrap = false }) => {
  const [active, setActive] = useState(selectedId);

  useEffect(() => {
    setActive(selectedId);
  }, [selectedId]);

  const onClick = useCallback(
    (option) => {
      if (active === option.id) return;

      setActive(option.id);
      if (onChange) onChange(option);
      if (option.onClick) option.onClick(option);
    },
    [onChange, active]
  );

  if (options.length < 2) {
    return null;
  }

  const align = gap === 'auto' ? 'space-between' : 'left';
  const gapProp = gap === 'auto' ? 'spacing-4-xs' : gap;

  return (
    <div className="ws-ui-action-radio-group">
      <HorizontalStack align={align} gap={gapProp} wrap={wrap}>
        {options.map((option) => {
          const isActive = option.id === active;
          return (
            <IconButton
              key={option.id}
              glyph={option.glyph}
              size="large"
              label={option.label}
              selected={isActive}
              onClick={() => onClick(option)}
              appearance="light-accent"
            />
          );
        })}
      </HorizontalStack>
    </div>
  );
};

ActionRadioGroup.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      glyph: PropTypes.string.isRequired,
      label: PropTypes.string,
      onClick: PropTypes.func,
    })
  ).isRequired,
  selectedId: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  gap: PropTypes.oneOf(['auto', ...SPACING]),
  wrap: PropTypes.bool,
};

export default ActionRadioGroup;
